import { Blinker } from "../../Common/Blinker";
// import '../../../input.css';

interface IProps {
    text: string;
    selected: boolean;
    fullWidth?: boolean;
}

export const ScreenOption: React.FC<IProps> = ({ text, selected, fullWidth }) => {
    const columnStyle = fullWidth ? 'w-full flex justify-center' : '';
    return (
        <div className={`interactions-text ${columnStyle} relative my-2`} >
            {
                selected
                    ? <p className="interactions-text text-md absolute min-w-3 top-[-4px] left-[-16px]">
                        <Blinker interval={550}>
                            <span className="text-xs">
                                {">"}
                            </span>
                        </Blinker>
                    </p>
                    : <div className="w-12 absolute" />
            }
            <p className={`font-pixel-text text-xs w-fit ${fullWidth ? 'text-center' : ''}`}>
                {text}
            </p>
        </div>
    )
}
